<template>
  <sui-page>
    <!-- Page Header -->
    <sui-page-header :pageId="this.$options.name" />

    <!-- Page Contents -->
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_GNRZ_AREA')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-code-select
              :selected="searchBox.generalizationAreaCode"
              :codeId="'COD_GNRZ_AREA'"
              :defaultOption="'all'"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SITE_ABBR')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model.trim="searchBox.siteAbbreviationName"
              maxlength="50"
              :disabled="false"
              :readonly="false"
              @keyup.enter="onSearch"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SITE_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model.trim="searchBox.siteName"
              maxlength="50"
              :disabled="false"
              :readonly="false"
              @keyup.enter="onSearch"
            />
          </div>
        </div>
        <div class="comm_detailscr_wrap">
          <div class="btn_wrap">
            <sui-button
              type="button"
              class="comm_btn_Reset "
              @click="onReset"
            >
              {{ $t("MSG_BTN_RESET") }}
            </sui-button>
            <sui-button
              type="button"
              class="comm_btn_Scr"
              @click="onSearch"
            >
              {{ $t("MSG_BTN_SEARCH") }}
            </sui-button>
          </div>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        :columns="gridColumns0"
        :dataset="'dataset0'"
        :multiselect="multiselect"
        :showDisplayCountControl="false"
        :sortable="false"
        :filterable="false"
        :initialPagesize="5"
      />
    </sui-page-contents>
    <sui-page-footer>
      <div class="comm_btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onCancel"
        >
          {{ this.$t('MSG_BTN_CANCEL') }}
        </sui-button>
        <sui-button
          type="button"
          class="comm_btn_solid"
          @click="onSelectedSite"
        >
          {{ this.$t('MSG_BTN_SELT') }}
        </sui-button>
      </div>
    </sui-page-footer>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMY_00016', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    closePagePopup: {
      type: Function,
      default: () => {},
    },
    pageInitialData: {
      type: Object,
      default() { return {}; },
    },
  },
  data() {
    return {
      multiselect: false,
      // Search Box
      searchBox: {
        // 선택된 select box 값
        generalizationAreaCode: { key: '', label: '' },
        siteAbbreviationName: '',
        siteName: '',
      },

      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_SITE_ID'),
        datafield: 'siteId',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_SITE_ABBR'),
        datafield: 'siteAbbreviationName',
        width: 150,
      }, {
        text: this.$t('MSG_TXT_SITE_ABBR_EN'),
        datafield: 'siteEnglishAbbreviationName',
        width: 150,
      }, {
        text: this.$t('MSG_TXT_SITE_NM'),
        datafield: 'siteName',
      }, {
        text: this.$t('MSG_TXT_GNRZ_AREA'),
        datafield: 'generalizationAreaName',
        width: 100,
      }],
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dataset0',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'siteId', map: 'siteId' },
      { type: 'string', name: 'siteName', map: 'siteName' },
      { type: 'string', name: 'siteAbbreviationName', map: 'siteAbbreviationName' },
      { type: 'string', name: 'siteEnglishAbbreviationName', map: 'siteEnglishAbbreviationName' },
      { type: 'string', name: 'generalizationAreaCode', map: 'generalizationAreaCode' },
      { type: 'string', name: 'generalizationAreaName', map: 'generalizationAreaName' },
      { type: 'string', name: 'businessSectorDivisionCode', map: 'businessSectorDivisionCode' },
      { type: 'string', name: 'businessSectorDivisionName', map: 'businessSectorDivisionName' },
      { type: 'string', name: 'nationCode', map: 'nationCode' },
      { type: 'string', name: 'langId', map: 'langId' },
      { type: 'string', name: 'langName', map: 'langName' },
      { type: 'string', name: 'currencyCode', map: 'currencyCode' },
      { type: 'string', name: 'arrayalOrder', map: 'arrayalOrder' },
      { type: 'string', name: 'siteInfoUseYn', map: 'siteInfoUseYn' },
    ],
  }],
  mounted() {
    this.loadData();
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    loadData() {
      if (this.pageInitialData != null) {
        const has = Object.prototype.hasOwnProperty;
        if (has.call(this.pageInitialData, 'multiselect')
             && this.pageInitialData.multiselect) {
          this.multiselect = this.pageInitialData.multiselect;
        }

        if (has.call(this.pageInitialData, 'siteAbbreviationName')
            && utils.isEmpty(this.pageInitialData.siteAbbreviationName) === false) {
          this.searchBox.siteAbbreviationName = this.pageInitialData.siteAbbreviationName;
        }

        if (has.call(this.pageInitialData, 'multiselect')
            && utils.isEmpty(this.pageInitialData.siteName) === false) {
          this.searchBox.siteName = this.pageInitialData.siteName;
        }
      }
    },
    /** ***************************************************************************
        이벤트 영역
      ***************************************************************************** */
    onReset() {
      this.resetSearchBox();
    },
    onSearch() {
      this.searchSite();
    },
    onSelectedSite() {
      this.selectedSite();
    },
    onCancel() {
      this.closePagePopup('');
    },
    /** ***************************************************************************
        함수 영역
      ***************************************************************************** */
    resetSearchBox() {
      const has = Object.prototype.hasOwnProperty;
      utils.forEach(this.searchBox, (values, key) => {
        if (has.call(this.searchBox[key], 'key')) {
          this.searchBox[key] = { key: '', label: '' };
        } else {
          this.searchBox[key] = '';
        }
      });

      this.searchBox.generalizationAreaCode.key = 'ALL';
    },
    searchSite() {
      // searchBox -> paramsObj변환 { key : value, key : value }
      const queryParams = utils.reduce(this.searchBox, (result, value, key) => {
        const objResult = utils.clone(result);
        if (utils.isUndefined(value) === false && value !== null) {
          objResult[key] = utils.isUndefined(value.key) ? utils.trim(value) : utils.trim(value.key);
        }
        return objResult;
      }, {});


      http.request(this.$options.name, 'DTS_CMY_00012', {
        query: queryParams,
      }).then(res => {
        console.log(res);
        this.dataset0.setRawData(res.data); // 데이터 셋에 데이터를 넣는 함수
      }).catch(error => {
        console.log(error);
      });
    },
    selectedSite() {
      const selectedRawsData = this.dataset0.getSelectedRawData();
      if (selectedRawsData.length <= 0) {
        utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM'), null, this.positiveHandler);
        return false;
      }
      this.closePagePopup(selectedRawsData);
      return true;
    },
  },
};
</script>
<style scoped>
</style>
